import { connect } from "react-redux";
import DisplayActions from "../../../../redux/DisplayRedux";
import ChangeAdButton from "../components/detail/ChangeAdButton";

const mapStateToProps = ({ display, userAccount }) => ({
  user: userAccount.user,
  token: userAccount.token,
  loadingChangeSpot: display.loadingChangeSpot,
  loadingChangeSpotSuccess: display.loadingChangeSpotSuccess,
  loadingChangeSpotInCampign: display.loadingChangeSpotInCampign,
  newSpotsChanged: display.newSpotsChanged,
});

const mapStateToDispatch = (dispatch) => ({
  updateContentCampaignRequest: (content, relation, campaignId) =>
    dispatch(DisplayActions.updateContentCampaignRequest(content, relation, campaignId)),
  updateContentDisplayByContent: (content, displayId) =>
    dispatch(DisplayActions.updateContentDisplayByContent(content, displayId)),
  loadingContentInCampaign: (status) =>
    dispatch(DisplayActions.loadingContentInCampaign(status)),
});

export default connect(mapStateToProps, mapStateToDispatch)(ChangeAdButton);
